import * as React from 'react';
import Svg, {
  SvgProps,
  Rect,
  Defs,
  LinearGradient,
  Stop,
} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={92}
    height={89}
    viewBox={'0 0 92 89'}
    {...props}
    fill={'none'}
    stroke={'none'}>
    <Rect
      width={91}
      height={88}
      x={0.5}
      y={0.5}
      fill={props.fill || '#033337'}
      fillOpacity={0.6}
      stroke="url(#a)"
      rx={44}
    />
    <Defs>
      <LinearGradient
        id="a"
        x1={0}
        x2={92}
        y1={44.5}
        y2={44.5}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#fff" />
        <Stop offset={0.32} stopColor="#003B49" />
        <Stop offset={0.68} stopColor="#003B49" />
        <Stop offset={1} stopColor="#fff" />
      </LinearGradient>
    </Defs>
  </Svg>
);
export default SvgComponent;
